import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ds-menu-divider',
  styles: [':host { display: contents; }'],
  template: '<hr class="ds-menu-divider">'
})
export class MenuDividerComponent {
  @HostBinding('attr.role') role = 'separator';
}
